export default __webpack_public_path__ + "static/abcright-b33f710b884fe912746f70bdf61844ed.png";